<template>
  <div class="beian">
    <div class="ba_main">
      <div class="balist"></div>
      <div class="balist" @click="getICP">蜀ICP备 12028597号</div>
      <div class="balist">版权所有©四川大学锦江学院</div>
    </div>
    <!-- <div class="ba_main"><div class="balist">川公网安备 110402430047 号</div>
    <div class="balist">蜀ICP备 12028597号</div>
      <div class="balist">版权所有©四川大学锦江学院</div></div> -->
  </div>
</template>

<script>
export default {
  name: 'pageFooter',
  data () {
    return {
      activeIndex: '0',
      input1: ''
    }
  },
  mounted () {
  },
  methods: {
    getICP () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
}
</script>
<style></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.balist {
  font-size: 12px;
  text-align: center;
}

.balist:nth-child(3) {
  margin-left: 5%;
}

@media screen and (max-width: 640px) {
  .ba_main {
    width: 100%;
    height: auto;
    display: flex;
    // flex-wrap: wrap;
    justify-content: center;
    line-height: 55px;
    text-align: center;
  }

  .balist {
    // text-align: left;
    // display: inline-block;
    height: auto;
    overflow: hidden;
    // transform: scale(.5);
    font-size: 8px;
    margin: 0 !important;
  }

  .balist:nth-child(1) {
    width: auto;
    display: block;
    margin: 0 !important;
    // font-size: 12px;
    // margin-left: 7% !important;
  }

  .balist:nth-child(2) {
    //  width: auto;
    // margin-left: 5% !important;
    // margin-left: .5rem !important;
    // font-size: 12px;
    // margin: 0 !important;
    margin-left: 10% !important;
    margin-right: 10% !important;
  }

  .balist:nth-child(3) {
    //  width: auto;
    // display: block;
    margin: 0 !important;
    // margin-right: 7% !important;
    padding: 0;
    // font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/beian.vue